import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiMongodb,
  SiNodedotjs,
  SiRedux,
  SiChakraui,
  SiJavascript,
  SiCss3,
  SiReact,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
import GitHubCalendar from "react-github-calendar";
export const Projects = () => {
  return (
    <>
      <div>
        <div id="projects">
          <h2
            style={{
              color: "#ff9838",
              fontSize: "xx-large",
              textAlign: "center",

              marginTop: "10px",
              margin: "50px",
              fontWeight: "bold",
            }}
          >
            PROJECTS
          </h2>
          <div className="projects_container">
            <div className="project">
              <div className="project_videocontainer">
                <div data-aos="fade-right">
                  <img src="https://i.imgur.com/18FMt4R.png" alt="Jewel Lane" />
                </div>
              </div>
              <div className="project_information" data-aos="fade-right">
                <h2>Jewel Lane Replica</h2>
                <p>
                  Clone of an e-commerce website Caratlane which sells the best
                  gold & diamond jewellery. Built on react for front end and
                  nodeJS on backend. It's a team project completed executed in 5
                  days. Main functionalities were : Register/Login using JWT,
                  Sorting and Filtering in the backend, Cart and Wish List and
                  many more.
                </p>
                <div>
                  <FaReact />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <SiNodedotjs />
                  <SiExpress />
                  <SiMongodb />
                </div>
                <div>
                  <a
                    href="https://jewellane.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/AditiSharma00/pointless-belief-3937"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container">
            <div className="project">
              <div className="project_videocontainer">
                <div data-aos="fade-right">
                  <img
                    src="https://user-images.githubusercontent.com/110106484/232668754-1d4bd47e-fdfe-427b-8994-ac1a33360d68.png"
                    alt="PharmEasy"
                  />
                </div>
              </div>
              <div className="project_information" data-aos="fade-right">
                <h2>PharmEasy Clone</h2>
                <p>
                  Clone of an e-commerce website PharmEasy.Techstack used is:
                  React,Redux,Html,CSS,Javascript,Chakra UI.There is login and
                  logout functionality. and elegant navbar for easy navigation
                  between pages and categories. Product Pages where all the
                  products are displayed using Api. Single Product Page on
                  clicking Each Product carrying description of that
                  product.Cart with Crud Operations and Payment Pages.
                </p>
                <div>
                  <IoLogoJavascript />
                  <FaReact />
                  <SiChakraui />
                  <SiRedux />
                </div>
                <div>
                  <a
                    href="https://pharmeasy-tan.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/AditiSharma00/decorous-pan-7664"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container">
            <div className="project">
              <div className="project_videocontainer">
                <div data-aos="fade-right">
                  <img src="https://i.imgur.com/5akWuMt.png" alt="" />
                </div>
              </div>
              <div className="project_information" data-aos="fade-right">
                <h2> Rock Paper and Scissor game</h2>
                <p>
                  Mini Project of Rock Paper and Scissor game using HTML, CSS
                  and JavaScript.
                </p>
                <div>
                  <SiCss3 />
                  <SiHtml5 />
                  <SiJavascript />
                </div>
                <div>
                  <a
                    href="https://aesthetic-souffle-fd1c0d.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline onbt">
                      URL for the API
                    </span>
                  </a>
                  <a
                    href="https://github.com/AditiSharma00/rock-paper-scissor"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container">
            <div className="project">
              <div className="project_videocontainer">
                <div data-aos="fade-right">
                  <img
                    src="https://i.imgur.com/r9tLirJ.png"
                    alt="Lecious Clone"
                  />
                </div>
              </div>
              <div className="project_information" data-aos="fade-right">
                <h2>Clone of Lecious</h2>
                <p>
                  Clone of a food e-commerce website that delivers food items to
                  the customer's doorstep.Features: •User Authentication
                  •Landing and product pages. •Can add,remove or increase the
                  quantity from the cart •Checkout and tracking page. •Sorting,
                  filter. •Admin page.
                </p>
                <div>
                  <SiJavascript />
                  <SiHtml5 />
                  <DiCss3 />
                </div>
                <div>
                  <a
                    href="https://sensational-wisp-a46f22.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/AditiSharma00/truthful-wing-8761"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container">
            <div className="project">
              <div className="project_videocontainer">
                <div data-aos="fade-right">
                  <img
                    src="https://i.imgur.com/IQ4VP41.png"
                    alt="chick fill A.com"
                  />
                </div>
              </div>
              <div className="project_information" data-aos="fade-right">
                <h2>Chick Fill A.com</h2>
                <p>
                  A food e-commerce website that delivers food items to the
                  customer's doorstep. Features : •Login, Signup, Logout
                  •Landing and Product page •Cart Page •Sort functionality
                  •Pagination
                </p>
                <div>
                  <SiReact />
                  <SiChakraui />
                </div>
                <div>
                  <a
                    href="https://soulful1.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/AditiSharma00/thin-thumb-2475"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btn btn--outline">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="gitname"
          margin={"auto"}
          justifyContent={"space-around"}
          data-aos="fade-right"
        >
          <h2
            style={{
              textAlign: "center",
              color: "#ff9838",
              fontSize: "xx-large",

              marginTop: "10px",
              margin: "50px",
              fontWeight: "bold",
            }}
          >
            DAYS I CODE
          </h2>
        </div>
        <div id="calendar" style={{ marginTop: "5px" }} data-aos="fade-right">
          <GitHubCalendar
            username="aditisharma00"
            blockSize={16}
            fontSize={14}
            colorScheme="dark"
          />
        </div>
        <div id="gitstats" data-aos="fade-right" style={{ marginTop: "50px" }}>
          <div>
            <img
              id="github-streak-stats"
              src="https://github-readme-streak-stats.herokuapp.com?user=aditisharma00&theme=transparent"
            />
          </div>
          <div>
            <img
              id="github-top-langs"
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=aditisharma00&layout=compact&theme=transparent"
              alt=""
            />
          </div>
          <div>
            <img
              id="github-stats-card"
              src="https://github-readme-stats.vercel.app/api?username=aditisharma00&show_icons=true&theme=transparent"
              alt=""
            />
          </div>
          <div id="Activitygraph">
            <img
              src="https://github-readme-activity-graph.vercel.app/graph?username=aditisharma00&theme=transparent"
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
};
